import React from 'react';
import { V2PlanFeature } from '../../utilities/types';
import { IconList } from '../../atoms/IconList';
import { PlanFeature } from './PlanFeature';
import { styles } from '../../organisms/plans-v2/styles';

interface PlanFeaturesProps {
  features: V2PlanFeature[];
}

export const PlanFeatures: React.FC<PlanFeaturesProps> = ({ features }) => {
  if (!features) return null;

  const renderedFeatures = features.map((feature) => {
    return <PlanFeature key={JSON.stringify(feature)} feature={feature} />;
  });

  return <IconList className={styles.iconList}>{renderedFeatures}</IconList>;
};
